var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mdiIcon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_c('svg',{staticClass:"v-icon__svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44","role":"img","aria-hidden":"true"}},[_c('path',{attrs:{"d":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }